import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { createGenerateClassName, StylesProvider } from '@material-ui/styles';

import CommonRoutes from './common.route';

import middlewares from './middlewares';

import LayoutWithMenu from '@common/containers/layout/layout.withMenu';
import LayoutExterno from '@common/externos/container/layout/layout.externo';
import BreadCrumb from '@common/components/breadcrumb/breadcrumb.component';
import TopFix from '@common/helpers/topFix.helper';

let mappedRoutes = [...CommonRoutes];

let currentRoute = {};

const generateClassName = createGenerateClassName({
  disableGlobal: true,
});

export function setRoutes(requireComponent) {
  requireComponent.keys().forEach((fileName) => {
    var routeImport = requireComponent(fileName).default;
    mappedRoutes = [...mappedRoutes, ...routeImport];
  });
}

export function getRoutes() {
  return mappedRoutes;
}

export function getCurrentRoute() {
  return currentRoute;
}

export function getUrlByName(name) {
  let target;
  if (name) target = getRoutes().find((x) => x.name == name);
  target = getRoutes().find((x) => x.name == name);
  return target ? target.path : undefined;
}

export function getUrlByNameIgnoreCase(webStorage) {
  let target;
  if (webStorage) target = getRoutes().find((x) => x.name?.toUpperCase() == webStorage.toUpperCase());
  return target ? target.path : undefined;
}

export function getNameByUrl(url) {
  const target = getRoutes().find((x) => x.path == url);
  return target ? target.name : undefined;
}

export function getRouteByName(name) {
  const target = getRoutes().find((x) => x.name == name);
  return target ? target : undefined;
}

const applyMiddlewares = (targetRoute, currentRoute) => {
  let nextRoute = targetRoute;
  middlewares.forEach((mid) => {
    nextRoute = mid(nextRoute, currentRoute);
  });
  return nextRoute;
};

function RouteWithLayout(props) {
  TopFix.topFix();
  const nextRoute = applyMiddlewares(props, currentRoute);
  currentRoute = nextRoute;

  return (
    <Route
      path={nextRoute.path}
      exact={true}
      render={(routerProps) => (
        <div className="container container-main">
          <BreadCrumb currentRoute={currentRoute} />
          <nextRoute.component {...routerProps} />
        </div>
      )}
    />
  );
}

function RouteWithLayoutExterno(props) {
  TopFix.topFix();
  const nextRoute = applyMiddlewares(props, currentRoute);
  currentRoute = nextRoute;

  return (
    <Route
      path={nextRoute.path}
      exact={true}
      render={(routerProps) => (
        <>
          <BreadCrumb currentRoute={currentRoute} />
          <nextRoute.component {...routerProps} />
        </>
      )}
    />
  );
}

function renderRouter() {
  return (
    <Router>
      <LayoutWithMenu>
        <Switch>
          {mappedRoutes.map((route, i) => (
            <RouteWithLayout component={route.component} key={i} exact={true} {...route} />
          ))}
        </Switch>
      </LayoutWithMenu>
    </Router>
  );
}

function renderRouterExterno(props) {
  return (
    <StylesProvider generateClassName={generateClassName}>
      <Router>
        <LayoutExterno title={props.title}>
          <Switch>
            {mappedRoutes.map((route, i) => (
              <RouteWithLayoutExterno component={route.component} key={i} exact={true} {...route} />
            ))}
          </Switch>
        </LayoutExterno>
      </Router>
    </StylesProvider>
  );
}

export default renderRouter;
export { renderRouterExterno };
